<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.stament_id" class="modal-card-title">Crear Estamento</p>
          <p v-else class="modal-card-title">Editar Estamento</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="stament.name"
              v-model="stament.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.stament_id" class="button is-primary" @click="createStament()">Guardar</button>
          <button v-else class="button is-primary" @click="editStament()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "chargeStamentList",
    "stament_id",
  ],
  data() {
    return {
      stament: {
        name: "",
      },
      isLoading: false,
    };
  },
  created: function () {
    this.isLoading = true;
    if (this.stament_id) {
      this.chargeStamentData().then(() => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    createStament: async function () {
      this.isLoading = true;
      let data = {
        ...this.stament,
      };
      await this.$http.post(`api/${localStorage.getItem('perfil')}/stament`, data).then(
        (response) => {
          //Limpia el objeto stablishment
          for (const i in this.stament) {
            this.stament[i] = "";
          }
          console.log("POST:", response.body);
          this.chargeStamentList();
          this.closeBasic();
          this.toast("Creado el Estamento", "is-success");
          this.isLoading = false;
        },
        (response) => {
          this.toast("Error al crear estamento", "is-danger");
          this.isLoading = false;
          console.log("error: ", response);
        }
      );
    },
    editStablishment: function () {
      this.isLoading = true;
      let data = {
        ...this.stament,
      };
      this.$http
        .put(`api/${localStorage.getItem('perfil')}/stament/` + this.stament_id, data)
        .then(
          (response) => {
            //Limpia el objeto prevition
            for (const i in this.stament) {
              this.stament[i] = "";
            }
            console.log("PUT:", response.body);
            this.chargeStamentList();
            this.closeBasic();
            this.toast("Editado el estamento", "is-success");
            this.isLoading = false;
          },
          (response) => {
            this.toast("Error al editar", "is-danger");
            this.isLoading = false;
            console.log("error: ", response);
          }
        );
    },
    chargeStamentData: async function () {
      await this.$http
        .get(`api/${localStorage.getItem('perfil')}/stament/` + this.stament_id)
        .then(
          (response) => {
            this.stament.name = response.body.stament.name;
          },
          (response) => {
            console.log(response);
          }
        );
    },
  },
};
</script>